import { CommonModule } from '@angular/common';
import { Component, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '../../environments/environment.prod';
import emailjs from '@emailjs/browser';
import { FullScreenModal } from '../full-screen-modal/full-screen-modal';
import { LoadingModal } from '../loading-modal/loading-modal';

@Component({
  selector: 'app-aszf',
  imports: [FormsModule, CommonModule, FullScreenModal, LoadingModal],
  templateUrl: './aszf.html',
  styleUrl: './aszf.css',
})
export class Aszf {
  name: string = '';
  email: string = '';
  startDate: string = '';
  endDate: string = '';
  isAccepted: boolean = false;
  isSendingInProgress: boolean = false;
  isSuccess: boolean = false;
  isError: boolean = false;
  isTermsModalOpen: boolean = false;

  private emailjsServiceId = environment.emailjsServiceId;
  private emailjsTemplateId = environment.emailjsTemplateId; 
  private emailjsPublicKey = environment.emailjsPublicKey; 

  constructor(private cdr: ChangeDetectorRef) {
    emailjs.init(this.emailjsPublicKey);
  }

  get isFormValid(): boolean {
    return this.name !== '' &&
           this.startDate !== '' &&
           this.endDate !== '' &&
           this.isAccepted;
  }

  async onSubmit(): Promise<void> {
    if (this.isFormValid && !this.isSendingInProgress) {
      this.isSendingInProgress = true;
      this.isSuccess = false;
      this.isError = false;

      const startDateFormatted = new Date(this.startDate).toLocaleDateString('hu-HU');
      const endDateFormatted = new Date(this.endDate).toLocaleDateString('hu-HU');
      const acceptingDate = new Date().toLocaleString('hu-HU');

      try {
        const templateParams = {
          to_email: 'kopcsakpatrik1@gmail.com',
          from_name: this.name,
          from_email: this.email,
          erkezes_datum: startDateFormatted,
          tavozas_datum: endDateFormatted,
          elfogadas_ideje: acceptingDate,
          message: `${this.name} elfogadta az ASZF-et.\n\nAdatok:\n- Név: ${this.name}\n- Email: ${this.email}\n- Érkezés: ${startDateFormatted}\n- Távozás: ${endDateFormatted}\n- Elfogadás időpontja: ${acceptingDate}`
        };

        const response = await emailjs.send(
          this.emailjsServiceId,
          this.emailjsTemplateId,
          templateParams
        );

        console.log('SUCCESS!', response.status, response.text);
        
        this.isSendingInProgress = false;
        this.isSuccess = true;
        this.cdr.detectChanges();
        
        this.resetForm();

        setTimeout(() => {
          this.isSuccess = false;
          this.cdr.detectChanges();
        }, 3000);

      } catch (error) {
        console.error('❌ Email küldési hiba:', error);
        this.isSendingInProgress = false;
        this.isError = true;
        this.cdr.detectChanges();
        
        setTimeout(() => {
          this.isError = false;
          this.cdr.detectChanges();
        }, 3000);
      }
    }
  }

  private resetForm(): void {
    this.name = '';
    this.email = '';
    this.startDate = '';
    this.endDate = '';
    this.isAccepted = false;
  }
}